import { Pipe, PipeTransform } from '@angular/core';
import {
    AbbreviatedTravellerXType, TravellerPrimitiveXType,
    TravellerXType
} from "libraries/service/resources/booking/interfaces/get-bookings.enum";
import { BookingType } from "@afidium/ts-facade/model/bookingType";
import { TravellerType } from "@afidium/ts-facade/model/travellerType";
import { Yii } from "../../../../../interfaces/Yii";

@Pipe({
    name: 'computeTravellerTitle'
})
export class ComputeTravellerTitlePipe implements PipeTransform {

    public transform(signature: string, booking: BookingType, travellers: TravellerType[] = [], forOptimisationSection: boolean = false, travellerType?: TravellerPrimitiveXType): string {
        let formattedTraveller: string = '';
        let firstNameInitial: string = '';
        let lastNameInitial: string = '';

        const travellersToFormat: TravellerType[] = booking ? booking?.travellerArray : travellers;
        const traveller: TravellerType = travellersToFormat?.find((travellerItem: TravellerType): boolean => travellerItem?.signature === signature);

        if (traveller) {
            firstNameInitial = this.getFirstCharacter(traveller.firstName);
            lastNameInitial = this.getFirstCharacter(traveller.lastName ?? traveller.name);
            formattedTraveller = `${this.getTravellerType(traveller.xType)} (`;
            if(firstNameInitial){
                formattedTraveller += `${firstNameInitial}`;
            }
            if(lastNameInitial){
                formattedTraveller += `${lastNameInitial}`;
            }
            formattedTraveller += ')';
        }

        if (forOptimisationSection) {
            switch (travellerType) {
                case TravellerPrimitiveXType.infant:
                    formattedTraveller += Yii.t('wui-shared-js', 'Bébés (');
                    break;
                case TravellerPrimitiveXType.child:
                    formattedTraveller += Yii.t('wui-shared-js', 'Enfants (');
                    break;
                default :
                    formattedTraveller += Yii.t('wui-shared-js', 'Adultes (');
                    break;
            }

            const initialTravellersArray: string[] = [];
            travellers.filter((travellerItem: TravellerType): boolean => travellerItem?.xType === travellerType)
                .forEach((travellerItem: TravellerType): void => {
                    const firstNameFirstLetter: string = this.getFirstCharacter(travellerItem?.firstName);
                    const lastNameFirstLetter: string = this.getFirstCharacter(travellerItem?.lastName ?? travellerItem.name);
                    const firstLetters: string = (firstNameFirstLetter ? firstNameFirstLetter : '') + (lastNameFirstLetter ? lastNameFirstLetter : '');
                    initialTravellersArray.push(firstLetters);
                });
            formattedTraveller += `${initialTravellersArray.join(' + ')})`;
        }
        return formattedTraveller;
    }

    public getFirstCharacter(firstOrLastName: string): string {
        if(firstOrLastName){
            return firstOrLastName.substr(0, 1).toUpperCase();
        }
    }

    public getTravellerType(travellerXTYpe: string): string {
        let simpleTravellerType: string;
        switch (travellerXTYpe.toLowerCase()) {
            case TravellerXType.infant:
                simpleTravellerType = AbbreviatedTravellerXType.INF;
                break;
            case TravellerXType.child:
                simpleTravellerType = AbbreviatedTravellerXType.CHD;
                break;
            default :
                simpleTravellerType = AbbreviatedTravellerXType.ADT;
                break;
        }
        return simpleTravellerType;
    }
}
